export const addCampaignSlideTitles = [
    'Country',
    'Budget',
    'Summary'
];